import React from 'react';
import { Link } from 'react-router-dom';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Phone } from 'lucide-react';

const FAQ = () => {
  const faqs = [
    {
      question: "What documents are required for ITR filing?",
      answer: "For salaried individuals: Form 16, Bank statements, Investment proofs (80C, 80D), Home loan interest certificate, Rent receipts (for HRA). For businesses: Books of accounts, Bank statements, GST returns, Purchase/Sale invoices, TDS certificates."
    },
    {
      question: "How long does GST registration take?",
      answer: "GST registration typically takes 3-7 working days after document submission. We handle the entire process including application filing, verification, and ARN tracking. Express processing available for urgent cases."
    },
    {
      question: "Do you handle tax notices from the department?",
      answer: "Yes, we provide complete notice handling services including scrutiny assessment, GST notices, income tax notices, and representation before tax authorities. We ensure timely response and proper documentation."
    },
    {
      question: "What is the last date for ITR filing?",
      answer: "For individuals (non-audit cases): July 31st of assessment year. For businesses requiring audit: October 31st. For belated returns: December 31st (with late fees). We recommend filing early to avoid last-minute rush."
    },
    {
      question: "Can you help with business loan applications?",
      answer: "Yes, we assist with Business Loans, Loan Against Property (LAP), Working Capital, and Housing Loans. We prepare project reports, financial statements, and help with documentation for faster loan approval."
    },
    {
      question: "How often should I file GST returns?",
      answer: "Regular taxpayers: GSTR-1 (monthly/quarterly), GSTR-3B (monthly). Composition scheme: GSTR-4 (quarterly). Annual return GSTR-9 (yearly). We provide timely reminders and handle all GST compliances."
    },
    {
      question: "What is the difference between Tax Audit and Statutory Audit?",
      answer: "Tax Audit (under Section 44AB) is mandatory for businesses with turnover above specified limits and focuses on tax compliance. Statutory Audit is required for companies/LLPs as per Companies Act and covers overall financial statements and internal controls."
    },
    {
      question: "Do you provide services for startups?",
      answer: "Yes, we offer complete startup services including Company/LLP registration, MSME registration, GST registration, accounting setup, tax planning, funding assistance, and ongoing compliance management at startup-friendly rates."
    },
    {
      question: "What are your working hours?",
      answer: "Monday to Saturday: 10:00 AM to 6:00 PM. For urgent matters during tax season or deadline days, we provide extended support. You can reach us via phone, WhatsApp, or email anytime."
    },
    {
      question: "How can I book a consultation?",
      answer: "You can book a FREE consultation by calling +91-6396550622, using the contact form on our website, or via WhatsApp. We offer both in-person and virtual consultations as per your convenience."
    }
  ];

  return (
    <div className="faq-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="container">
          <h1 className="page-hero-title">Frequently Asked Questions</h1>
          <p className="page-hero-subtitle">
            Find answers to common questions about our CA services
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="faq-content-section">
        <div className="container">
          <div className="faq-intro">
            <p className="faq-intro-text">
              Have questions about GST, Income Tax, Audit, or our services? Browse through our 
              frequently asked questions below. Can't find what you're looking for? Feel free to 
              contact us directly!
            </p>
          </div>

          <div className="faq-accordion-wrapper">
            <Accordion type="single" collapsible className="faq-accordion">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="faq-item">
                  <AccordionTrigger className="faq-question">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="faq-answer">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>

          {/* CTA */}
          <div className="faq-cta">
            <h3 className="faq-cta-title">Still Have Questions?</h3>
            <p className="faq-cta-text">
              Our team is here to help you with personalized answers
            </p>
            <div className="faq-cta-buttons">
              <Link to="/contact" className="btn btn-primary">
                Contact Us
              </Link>
              <a href="tel:+916396550622" className="btn btn-secondary">
                <Phone size={20} />
                Call +91-6396550622
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
